import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AlertContext from '../../Context/Alert/AlertContext';

const PricingCard = ({ item, checked, subfunction, submit, buttontext }) => {
  const navigate = useNavigate()
  const { showAlert } = useContext(AlertContext)
  return (
    <div className={item?.Popular ? "w-96 mx-8 bg-white shadow-lg rounded-lg overflow-hidden" : "w-96 mx-8 bg-white shadow-lg rounded-lg overflow-hidden max-h-5/6"} >
      <div className={item?.Popular && 'bg-primarygreen flex flex-col justify-content  align-middle px-1 py-1 rounded-lg'}  >
        {item?.Popular &&
          <div className='min-h-10 flex items-center justify-center '>
            <span className='font-pop text-lg font-medium text-white'>Most Popular</span>
          </div>}
        <div className="px-4 py-6 z-20 bg-white rounded-lg">
          <h2 className="font-semibold font-pop text-xl mb-4">{item?.AccountType} Plan</h2>
          <div className=" mb-4">
            <span className="text-4xl font-pop font-semibold">${item?.Price}</span>
            <span className="text-lightGrey font-pop text-2xl font-semibold"> {(checked) ? "/Yearly" : "/Month"}</span>
          </div>

          <div className='flex flex-col gap-2 mb-2 ' >
            <span className='text-lightGrey text-lg font-pop font-normal block'>Charge fee from every order that has been created:</span>
            <span className=' text-lg font-pop font-medium block'>As a Buyer: {item?.Buyer?.Fees}% + {item?.Buyer?.Cent}</span>
            <span className=' text-lg font-pop font-medium block'>As a Seller: {item?.Seller?.Fees}% + {item?.Seller?.Cent}</span>
          </div>

          <button
            className={item?.Popular ? " my-2 lg:my-4 font-pop text-base bg-primarygreen hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-primarygreen py-2 px-4 border border-black-500 hover:border-primarygreen rounded-full w-full text-white "
              : "my-2 lg:my-4 font-pop text-base bg-white  hover:bg-primarygreen font-semibold hover:text-white py-2 px-4 border border-primarygreen hover:border-primarygreen rounded-full w-full text-primarygreen "
            }
            onClick={() => {
              if (subfunction) {
                submit()
              } else {
                if (localStorage.getItem("p@token")) {
                  navigate("/profileCreation")
                } else {
                  showAlert('You need to Login first or Create Account', 'danger');
                  navigate('/signin')
                }
              }
            }}
          >
            {buttontext ? buttontext : "Get Started"}
          </button>
        </div>

      </div>
    </div >
  );
};

export default PricingCard